// Rueckfall 'dev': Fehlt die Variable beim Bauen, soll das sichtbar sein
// statt einer erfundenen 1.0.0. Quelle ist die Datei VERSION (ci.yml).
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || 'dev';
